import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MaskService {

  private mask = new BehaviorSubject<Mask>(new Mask());

  constructor() { }

  public setMask(mask: string, value: boolean): void {
    this.mask.next({...this.mask.value, [mask]: value});
  }

  public getMask(): Observable<Mask> {
    return this.mask;
  }

}

export class Mask {
  static fullPageMask: string = "fullPageMask";
  fullPageMask: Boolean = false;

  static multisesionErrorMask: string = "multisesionErrorMask";
  multisesionErrorMask: Boolean = false;

  static basicMask: string = "basicMask";
  basicMask: Boolean = false;
}
